module.exports = __webpack_public_path__ + "static/68gde-03f13ea6f932eaea672c3a4c7ceb0683.gif";